"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackbarChart = void 0;
var drawPlane_1 = require("../parse/drawPlane");
var getPlanes_1 = require("../parse/getPlanes");
var getIndexNearest_1 = require("../../common/getIndexNearest");
var StackbarChart = function (svg, config) {
    var _a, _b;
    var _c = getPlanes_1.getPlanes(config), dataPointGroup = _c.dataPointGroup, yAxisMarks = _c.yAxisMarks, destPlane = _c.destPlane;
    drawPlane_1.drawPlane(svg, config, dataPointGroup[0], yAxisMarks, destPlane);
    var GAP = 20;
    var barSize = (config.width - config.xAxis.marginEnd - config.xAxis.marginStart) / (dataPointGroup[0].length) - GAP;
    barSize = Math.min(48, barSize);
    barSize = Math.max(12, barSize);
    Array.from(new Array(dataPointGroup[0].length)).map(function (_, i) {
        for (var j = 0; j < dataPointGroup.length; j++) {
            var height = destPlane[0][0][1] - dataPointGroup[j][i][1];
            dataPointGroup[j][i][1] = j === 0 ? dataPointGroup[j][i][1] : dataPointGroup[j - 1][i][1] - height;
            svg.rect(barSize, height).move(dataPointGroup[j][i][0], dataPointGroup[j][i][1]).fill(config.values[j].color);
        }
    });
    if (config.cursorX) {
        var LINE_COLOR = '#000';
        var fontSize_1 = config.yAxis.fontSize || 30;
        var nearestIndex = getIndexNearest_1.getIndexNearest(dataPointGroup, config.cursorX);
        var index_1 = nearestIndex.indexX;
        var nearest = nearestIndex.nearestX;
        var points_1 = dataPointGroup.map(function (it) { return it[index_1]; });
        var yText_1 = "" + config.values.reduce(function (acc, it) { return acc + it.series[index_1]; }, 0);
        svg.rect(fontSize_1 * 0.58 * yText_1.length + 8, fontSize_1 * 1.8 * (((_a = yText_1.split('').filter(function (it) { return it === "\n"; })) === null || _a === void 0 ? void 0 : _a.length) + 1)).move(Math.max(config.xAxis.marginStart - fontSize_1 * 3, fontSize_1 * 0.6) - 5, points_1[points_1.length - 1][1] - fontSize_1).fill({ color: config.backgroundColor || '#fff' });
        svg.text(function (tspan) { return tspan.move(Math.max(config.xAxis.marginStart - fontSize_1 * 3, fontSize_1 * 0.6), points_1[points_1.length - 1][1] - fontSize_1)
            .text(yText_1)
            .font({ size: fontSize_1, weight: 'bold' }); });
        var xText_1 = "" + config.xAxis.series[index_1];
        svg.rect(fontSize_1 * 0.3 * xText_1.length + 8, fontSize_1 * 2 * (((_b = xText_1.split('').filter(function (it) { return it === "\n"; })) === null || _b === void 0 ? void 0 : _b.length) + 1)).move(dataPointGroup[0][index_1][0] - (xText_1.split("\n")[0].length * fontSize_1 * 0.4) / 2 - fontSize_1 * 0.3, config.height - config.yAxis.marginEnd + 2).fill({ color: config.backgroundColor || '#fff' });
        svg.text(function (tspan) { return tspan.move(dataPointGroup[0][index_1][0] - (xText_1.split("\n")[0].length * fontSize_1 * 0.4) / 2, config.height - config.yAxis.marginEnd)
            .text(xText_1)
            .font({ size: fontSize_1, weight: 'bold' }); });
        svg.line(nearest[0], config.yAxis.marginStart, nearest[0], config.height - config.yAxis.marginEnd + fontSize_1 * 0.4).stroke({ color: LINE_COLOR, width: 2 });
        svg.line(config.xAxis.marginStart - fontSize_1 * 0.4, points_1[points_1.length - 1][1], config.width - config.xAxis.marginEnd, points_1[points_1.length - 1][1]).stroke({ color: LINE_COLOR, width: 2 });
    }
    var getXY = function (x, y) { return getIndexNearest_1.getIndexNearest(dataPointGroup, x, y); };
    return { svg: svg, getXY: getXY };
};
exports.StackbarChart = StackbarChart;
